// Mock data for Aman Kharzoum Portfolio

export const personalInfo = {
  name: "Aman Kharzoum",
  title: "Senior Software Engineer",
  subtitle: "Mobile & Web Application Developer | Flutter, React & .NET Specialist",
  bio: "Experienced software engineer with 4+ years in mobile and web development, specializing in Flutter, ReactJS, and C#. I deliver high-performance, scalable applications while leading development teams and mentoring junior developers. Passionate about clean code, agile methodologies, and creating exceptional user experiences.",
  email: "aman.kharzoum@gmail.com",
  phone: "(963)949924759",
  linkedin: "https://www.linkedin.com/in/aman-kharzoum-36b3a7328/",
  github: "https://github.com/Sereen-Kh",
  location: "Damascus, Syria",
  resumeUrl: "https://customer-assets.emergentagent.com/job_11265213-519c-40eb-a221-aa63537cc337/artifacts/mpuaj1ok_Aman_Kharzoum_Resume.pdf"
};

export const skills = {
  backend: [
    { name: "ASP.Net Core", level: 88 },
    { name: "ASP.Net MVC", level: 85 },
    { name: "C#", level: 90 },
    { name: "Java", level: 75 },
    { name: "SQL", level: 85 },
    { name: "MongoDB", level: 80 },
    { name: "SQLite", level: 80 },
    { name: "Firebase", level: 85 }
  ],
  frontend: [
    { name: "Flutter", level: 90 },
    { name: "React", level: 85 },
    { name: "React Native", level: 80 },
    { name: "Xamarin Forms", level: 85 },
    { name: "WPF", level: 80 },
    { name: "HTML/CSS", level: 88 }
  ],
  tools: [
    { name: "Git/GitHub", level: 90 },
    { name: "VS Code", level: 90 },
    { name: "Swagger API", level: 85 },
    { name: "GraphQL", level: 80 },
    { name: "AppCenter", level: 85 },
    { name: "Firebase", level: 85 },
    { name: "Power BI", level: 75 }
  ]
};

export const projects = [
  {
    id: 1,
    title: "Humani App",
    description: "Led development and enhancement of the Humani App using Flutter and Riverpod for efficient state management. Implemented comprehensive test coverage including widget and integration tests, with CI/CD pipelines. Achieved 15% increase in user engagement through rich animations and smooth UI transitions.",
    techStack: ["Flutter", "Riverpod", "Firebase", "CI/CD", "AppCenter"],
    image: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=800&q=80",
    githubUrl: "#",
    liveUrl: "#",
    featured: true
  },
  {
    id: 2,
    title: "Production-Grade Mobile Apps",
    description: "Led development team in creating and launching highly functional mobile applications for iOS and Android using Flutter and Xamarin Forms. Published multiple apps to App Store and Google Play. Integrated with AppCenter, Firebase, Global Payment systems, and Notifications.",
    techStack: ["Flutter", "Xamarin Forms", "MVVM", "AppCenter", "Firebase"],
    image: "https://images.unsplash.com/photo-1551650975-87deedd944c3?w=800&q=80",
    githubUrl: "#",
    liveUrl: "#",
    featured: true
  },
  {
    id: 3,
    title: "GrandNode E-Commerce Platform",
    description: "Worked with GrandNode e-commerce platform, building custom packages for mobile apps with Provider and Bloc state management. Integrated mobile applications with payment gateways and notification systems.",
    techStack: ["Flutter", "Provider", "Bloc", "GrandNode", "Payment Gateway"],
    image: "https://images.unsplash.com/photo-1557821552-17105176677c?w=800&q=80",
    githubUrl: "#",
    liveUrl: "#",
    featured: true
  },
  {
    id: 4,
    title: "Production Line Management System",
    description: "Designed relational databases and built desktop applications using WPF for production line projects. Created comprehensive reports using Power BI. Resolved critical bugs, reducing crash rate and improving application load speed by 10%.",
    techStack: ["WPF", "C#", "SQL", "Power BI", "MVVM"],
    image: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800&q=80",
    githubUrl: "#",
    liveUrl: "#",
    featured: false
  },
  {
    id: 5,
    title: "Enterprise Mobile Solutions",
    description: "Analyzed user requirements and designed APIs for mobile applications. Implemented unit testing and test automation. Produced fully functional mobile applications with clean, maintainable code across multiple platforms.",
    techStack: ["Mobile Development", "REST API", "Unit Testing", "CI/CD"],
    image: "https://images.unsplash.com/photo-1484480974693-6ca0a78fb36b?w=800&q=80",
    githubUrl: "#",
    liveUrl: "#",
    featured: false
  },
  {
    id: 6,
    title: "Cross-Platform Development",
    description: "Collaborated with international teams to define and design new features. Focused on bug fixing and improving application performance using agile methodology and Git for version control.",
    techStack: ["Cross-Platform", "Agile", "Git", "Performance Optimization"],
    image: "https://images.unsplash.com/photo-1504608524841-42fe6f032b4b?w=800&q=80",
    githubUrl: "#",
    liveUrl: "#",
    featured: false
  }
];

export const experience = [
  {
    id: 1,
    company: "Humani",
    position: "Flutter Developer",
    duration: "March 2024 - July 2025",
    location: "Remote",
    description: "Led the development and enhancement of the Humani App using Flutter and Riverpod. Developed fully functional mobile applications with clean, scalable code. Implemented comprehensive test coverage with CI/CD pipelines.",
    current: true
  },
  {
    id: 2,
    company: "OPStudioz",
    position: "Senior Software Engineer",
    duration: "October 2020 - March 2024",
    location: "Remote",
    description: "Led development team creating mobile applications for iOS/Android using Flutter and Xamarin Forms. Published multiple production-grade apps to App Store and Google Play. Mentored junior developers and worked with GrandNode e-commerce platform.",
    current: false
  },
  {
    id: 3,
    company: "Flora",
    position: "Software Developer",
    duration: "December 2019 - October 2020",
    location: "Damascus",
    description: "Analyzed user requirements and designed reports using Power BI. Designed relational databases and built desktop applications using WPF. Resolved critical bugs, improving performance by 10%.",
    current: false
  },
  {
    id: 4,
    company: "L-one Systems GmbH",
    position: "Mobile Application Developer",
    duration: "August 2018 - November 2019",
    location: "Damascus",
    description: "Developed application structure and collaborated with international team. Worked on bug fixing and improving application performance using agile methodology.",
    current: false
  },
  {
    id: 5,
    company: "SyrianSoft (Al-Ameen)",
    position: "Mobile Application Developer",
    duration: "December 2015 - July 2018",
    location: "Damascus",
    description: "Analyzed user requirements, designed and wrote APIs. Produced fully functional mobile applications with clean code. Created tables, stored procedures, and implemented unit testing.",
    current: false
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Project Manager",
    position: "Humani",
    content: "Aman's technical expertise and dedication to quality made a significant impact on our app's success. His implementation of CI/CD pipelines improved our deployment process tremendously.",
    avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=1"
  },
  {
    id: 2,
    name: "Team Lead",
    position: "OPStudioz",
    content: "Working with Aman was a pleasure. He consistently delivered high-quality code and mentored junior developers effectively. His problem-solving skills are exceptional.",
    avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=2"
  }
];
